import { useFormContext, Controller } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { styled } from 'goober';

import { Input, Error as InputError } from '@/ui/input/input';
import { BorderedTextArea } from '@/ui/textarea/bordered-text-area';
import { Stack } from '@/ui/line/line';
import { WithLabel } from '@/features/action-panel/meetings/ui/with-label';

import type { RequestProjectFormFields } from './request-project-validation-schema';

export function RequestProjectFormFields() {
  const { t } = useTranslation('request-project');
  const {
    register,
    control,
    formState: { errors },
  } = useFormContext<RequestProjectFormFields>();

  return (
    <Container gap="24px">
      <WithLabel
        name="name-field"
        labelText={t`form.name.label`}
        labelPosition="top"
        isRequired
      >
        <Input
          placeholder={t`form.name.placeholder`}
          {...register('name')}
          error={errors?.name?.message}
        />
      </WithLabel>

      <WithLabel
        name="email-field"
        labelText={t`form.email.label`}
        labelPosition="top"
        isRequired
      >
        <Input
          type="email"
          placeholder={t`form.email.placeholder`}
          {...register('email')}
          error={errors?.email?.message}
        />
      </WithLabel>

      <WithLabel
        name="business-unit-field"
        labelText={t`form.businessUnit.label`}
        labelPosition="top"
        isRequired
      >
        <Input
          placeholder={t`form.businessUnit.placeholder`}
          {...register('businessUnit')}
          error={errors?.businessUnit?.message}
        />
      </WithLabel>

      <WithLabel
        name="description-field"
        labelText={t`form.description.label`}
        labelPosition="top"
        isRequired
      >
        <DescriptionFieldWrapper>
          <Controller
            name="description"
            control={control}
            render={({ field: { onChange, onBlur, value } }) => (
              <>
                <BorderedTextArea
                  id="request-project-description"
                  value={value}
                  onChange={onChange}
                  onBlur={onBlur}
                  placeholder={t`form.description.placeholder`}
                  height={240}
                  resize="vertical"
                  error={!!errors?.description?.message}
                />
                {errors?.description?.message && (
                  <InputError>{errors.description.message}</InputError>
                )}
              </>
            )}
          />
        </DescriptionFieldWrapper>
      </WithLabel>
    </Container>
  );
}

const Container = styled(Stack)`
  width: 100%;
`;

const DescriptionFieldWrapper = styled('div')`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;
